import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { getTenantPreLoginConfig } from '../../tenant/teanantPreLoginConfig';
import { TENANTS_NAMES } from '../../tenant/host_config';
import { OntimeSpinnerComponent } from '@ontruck/fe-ontime';

const style = {
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    backgroundColor: '#ccc',
  },
  loadingText: {
    color: '#222',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '80px',
  },
};

class LoadingBig extends React.PureComponent {
  render() {
    const { components = [], intl } = this.props;

    const t = intl.messages.components.Loading;

    const tenantThemeName = getTenantPreLoginConfig().styles;

    return (
      <div style={style.loadingContainer}>
        {tenantThemeName === TENANTS_NAMES.ontime ? (
          <OntimeSpinnerComponent />
        ) : (
          <p style={style.loadingText}>{t.title_capitalize}</p>
        )}
        <ul>
          {components.map(({ ready, name }) => (
            <li key={name}>
              {name}: {ready ? 'DONE' : t.title_lower}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

LoadingBig.propTypes = {
  intl: PropTypes.any,
  components: PropTypes.array,
};

const intlLoadingBig = injectIntl(LoadingBig);

export { intlLoadingBig as LoadingBig };
